import React, { useContext } from 'react';

import LeadConversationsContext, {
  ConversationBucket,
} from '../../../../context/LeadConversationsContext/LeadConversationsContext';

import texts from '../../texts.json';
import { StyledTabComponent } from './styles';

const tabsConfig = {
  [ConversationBucket.OPEN]: {
    label: texts.openBucket,
  },
  [ConversationBucket.ARCHIVED]: {
    label: texts.archivedBucket,
  },
};

const ConversationBucketSelect = () => {
  const {
    selectedBucket,
    setSelectedBucket,
  } = useContext(LeadConversationsContext);

  return (
    <StyledTabComponent
      tabsConfig={tabsConfig}
      selectedTab={selectedBucket}
      onSelectTab={setSelectedBucket}
    />
  );
};

export default ConversationBucketSelect;
